export default __webpack_public_path__ + "static/media/roboto.21796d82.ttf";